// Imports
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useAppDispatch } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../shareables/integrations/api/redux/actions';
import { GetFAQsResponse } from '../../../../../../shareables/types/api/main/website/page/type/211/faqs/get';


// Styled components
const Container = styled.div`
	line-height: 1.3125rem;
	white-space: pre-line;
	overflow-wrap: anywhere;
	
	h4 {
		font-weight: bold;
		font-size: 1.125rem;
		margin-top: 0.625rem;
		margin-bottom: 0.625rem;
		line-height: 1.1;
	}
	
	hr {
		margin-top: 1.25rem;
		margin-bottom: 1.25rem;
		border: 0;
		border-top: 0.0625rem solid #eee;
	}
`;


// Define the accepted props
interface Props {
	pageID: number;
	storybookFAQs?: GetFAQsResponse;
}


// Function component
const Faqs: React.FC<Props> = ({ pageID, storybookFAQs }) => {
	// Use state
	const [faqs, setFAQs] = useState<GetFAQsResponse | null>(storybookFAQs ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load faqs on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetFAQsResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/page/id_${pageID}/type/211/faqs`,
				completion: (json) => {
					setFAQs(json.response);
				},
			})
		);
	}, [dispatch, pageID]);
	
	
	// If loading, display nothing
	if (faqs === null) {
		return null;
	}
	
	
	// Return JSX
	return (
		<Container>
			{faqs.map((faq, i) => {
				return (
					<React.Fragment key={faq.id}>
						<h4>
							<FontAwesomeIcon icon={faQuestionCircle} size='sm' /> {faq.question}
						</h4>
						{faq.answer}
						{i < faqs.length - 1 && <hr />}
					</React.Fragment>
				);
			})}
			
			{faqs.length === 0 && <em>No FAQs yet…</em>}
		</Container>
	);
};

export default Faqs;
